import { createAsyncThunk } from "@reduxjs/toolkit";
import { clientInvestSdk } from "@utils/clientInvestSdk";
import { logException } from "@helpers/logException/logException";
import {
  TaxResidency,
  CreateTaxResidencyInput,
  UpdateTaxResidencyInput,
} from "@ifgengineering/client-invest-sdk";

export const DELETE_TAX_RESIDENCY = "DELETE_TAX_RESIDENCY";

export const deleteTaxResidencyThunk = createAsyncThunk<string, string>(
  DELETE_TAX_RESIDENCY,
  async (id, { rejectWithValue }) => {
    try {
      await clientInvestSdk.deleteTaxResidency(id);
      return id;
    } catch (e: any) {
      logException({
        tag: "deleteTaxResidencyThunk",
        exception: e,
      });
      return rejectWithValue(e);
    }
  }
);

export const CREATE_TAX_RESIDENCY = "CREATE_TAX_RESIDENCY";

export const createTaxResidencyThunk = createAsyncThunk<
  TaxResidency,
  CreateTaxResidencyInput
>(CREATE_TAX_RESIDENCY, async (data, { rejectWithValue }) => {
  try {
    const response = await clientInvestSdk.createTaxResidency(data);
    return response.data;
  } catch (e: any) {
    logException({
      tag: "createTaxResidencyThunk",
      exception: e,
    });
    return rejectWithValue(e);
  }
});

export const UPDATE_TAX_RESIDENCY = "UPDATE_TAX_RESIDENCY";

export const updateTaxResidencyThunk = createAsyncThunk<
  TaxResidency,
  { id: string; data: UpdateTaxResidencyInput }
>(UPDATE_TAX_RESIDENCY, async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await clientInvestSdk.updateTaxResidency(id, data);
    return response.data;
  } catch (e: any) {
    logException({
      tag: "updateTaxResidencyThunk",
      exception: e,
    });
    return rejectWithValue(e);
  }
});
